import React from "react";
import { DisplayBox, Loading } from "../../components";
import { ApiHelper, EnvironmentHelper } from "../../helpers";
import { FileHelper } from "../../helpers/FileHelper";

interface Props {
  contentType: string,
  contentId: number
}

export const Attachments: React.FC<Props> = props => {

  const [attachments, setAttachments] = React.useState<string[]>([])

  const init = () => {
    ApiHelper.get("/files/" + props.contentType + "/" + props.contentId).then(data => setAttachments(data));
  }

  React.useEffect(init, []) //eslint-disable-line

  const handleDelete = (fileName: string) => {
    ApiHelper.delete("/files/" + props.contentType + "/" + props.contentId + "?fileName=" + encodeURI(fileName))
      .then(() => init());
  }


  const handleFileChange = async () => {
    const fileId = "attachmentUpload";
    const field: any = document.getElementById(fileId);
    const f = field.files[0];
    await FileHelper.preUpload(props.contentType, props.contentId, 0, f, f.name, () => { });
    init();
  }

  const getUploadButton = () => {
    return (<>
      <a href="about:blank" onClick={(e) => { e.preventDefault(); document.getElementById("attachmentUpload").click(); }} className="btn btn-sm btn-success" >Upload</a>
      <input type="file" style={{ display: "none" }} id="attachmentUpload" onChange={handleFileChange} />
    </>);
  }


  const getTable = () => {
    if (attachments === null) return <Loading />
    else {
      if (attachments.length === 0) return <p>No attachments have been added yet. Click the +New button to upload an attachment.</p>
      else {
        const rows: React.ReactElement[] = [];
        attachments.forEach(a => {
          const attachment = a;
          const deleteLink = <a href="about:blank" onClick={(e) => { e.preventDefault(); handleDelete(attachment) }}><i className="far fa-trash-alt text-danger"></i></a>
          rows.push(<tr>
            <td><a href={EnvironmentHelper.ContentRoot + "/" + props.contentType + "/" + props.contentId + "/" + a} target="_blank" rel="noreferrer" >{a}</a></td>
            <td>{deleteLink}</td>
          </tr>)
        });

        return (<table className="table table-sm table-striped">
          <thead>
            <tr><th>File</th><th>Action</th></tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>)
      }
    }
  }


  return (
    <>
      <DisplayBox headerText="Attachments" headerIcon="fas fa-paperclip" editContent={getUploadButton()} >
        {getTable()}
      </DisplayBox>
    </>
  );
};